// extracted by mini-css-extract-plugin
export var container = "_cc-0";
export var containerTopRight = "_cc-1";